interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  size?: "small" | "medium" | "large" | "xlarge";
  disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  size = "medium",
  disabled = false, // Default to false
}) => {
  const sizeMapping = {
    small: {
      height: "h-6",
      width: "w-12",
      knobSize: "h-5 w-5",
      knobTranslate: "translate-x-6",
    },
    medium: {
      height: "h-8",
      width: "w-16",
      knobSize: "h-7 w-7",
      knobTranslate: "translate-x-8",
    },
    large: {
      height: "h-10",
      width: "w-20",
      knobSize: "h-9 w-9",
      knobTranslate: "translate-x-10",
    },
    xlarge: {
      height: "h-12",
      width: "w-24",
      knobSize: "h-11 w-11",
      knobTranslate: "translate-x-12",
    },
  };

  const { height, width, knobSize, knobTranslate } = sizeMapping[size];

  return (
    <label className="flex cursor-pointer items-center justify-between gap-4">
      {label && <span className="text-lg font-semibold text-black">{label}</span>}
      <div
        className={`relative ${height} ${width} flex-shrink-0 rounded-full ${
          checked ? "bg-sidebar" : "bg-gray-300"
        } transition-colors ${disabled ? "bg-gray-200 cursor-not-allowed" : ""}`}
        onClick={() => !disabled && onChange(!checked)} // Prevent toggle when disabled
      >
        <div
          className={`absolute left-1 top-1/2 ${knobSize} -translate-y-1/2 transform rounded-full bg-white transition-transform ${
            checked ? knobTranslate : ""
          }`}
        />
      </div>
    </label>
  );
};

export default ToggleSwitch;
